import { render, staticRenderFns } from "./AskDown.vue?vue&type=template&id=4314332a&scoped=true"
import script from "./AskDown.vue?vue&type=script&lang=js"
export * from "./AskDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4314332a",
  null
  
)

export default component.exports